var _path, _path2, _rect, _path3, _path4, _rect2, _path5, _path6, _rect3, _path7, _path8, _rect4, _path9, _path10, _rect5, _path11, _path12, _rect6, _path13, _path14, _rect7, _path15, _path16, _rect8, _path17, _path18, _rect9, _path19, _path20, _rect10, _path21, _circle, _path22;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgErrorGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 141,
    viewBox: "0 0 137 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41026 99H41L32.5897 107.615H0L8.41026 99Z",
    fill: "#E6EEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 132.385L41 99L32.5897 107.615L32.5897 141L41 132.385Z",
    fill: "#C5D3D5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 107.615,
    width: 32.5897,
    height: 33.3846,
    fill: "#D8E1E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4103 99H73L64.5897 107.615H32L40.4103 99Z",
    fill: "#E6EEF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 132.385L73 99L64.5897 107.615L64.5897 141L73 132.385Z",
    fill: "#C5D3D5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 107.615,
    width: 32.5897,
    height: 33.3846,
    fill: "#D8E1E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4103 99H105L96.5897 107.615H64L72.4103 99Z",
    fill: "#E6EEF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105 132.385L105 99L96.5897 107.615L96.5897 141L105 132.385Z",
    fill: "#C5D3D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 107.615,
    width: 32.5897,
    height: 33.3846,
    fill: "#D8E1E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.41 99H137L128.59 107.615H96L104.41 99Z",
    fill: "#E6EEF4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137 132.385L137 99L128.59 107.615L128.59 141L137 132.385Z",
    fill: "#AEBEC0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 107.615,
    width: 32.5897,
    height: 33.3846,
    fill: "#C4D2D5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41026 66H41L32.5897 74.6154H0L8.41026 66Z",
    fill: "#DFE8EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99.3846L41 66L32.5897 74.6154L32.5897 108L41 99.3846Z",
    fill: "#AEBEC0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 74.6154,
    width: 32.5897,
    height: 33.3846,
    fill: "#C4D2D5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.41 67H137L128.59 75.4103H96L104.41 67Z",
    fill: "#E6EEF4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137 99.5897L137 67L128.59 75.4103L128.59 108L137 99.5897Z",
    fill: "#C5D3D5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 75.4103,
    width: 32.5897,
    height: 32.5897,
    fill: "#D8E1E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41026 33H41L32.5897 41.6154H0L8.41026 33Z",
    fill: "#CB2E2E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41 66.3846L41 33L32.5897 41.6154L32.5897 75L41 66.3846Z",
    fill: "#BE1B1B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 41.6154,
    width: 32.5897,
    height: 33.3846,
    fill: "#E15555"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4103 33H73L64.5897 41.6154H32L40.4103 33Z",
    fill: "#CB2E2E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66.3846L73 33L64.5897 41.6154L64.5897 75L73 66.3846Z",
    fill: "#BE1B1B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 41.6154,
    width: 32.5897,
    height: 33.3846,
    fill: "#E15555"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4103 33H105L96.5897 41.6154H64L72.4103 33Z",
    fill: "#CB2E2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105 66.3846L105 33L96.5897 41.6154L96.5897 75L105 66.3846Z",
    fill: "#BE1B1B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 41.6154,
    width: 32.5897,
    height: 33.3846,
    fill: "#E15555"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4103 0H73L64.5897 8.61539H32L40.4103 0Z",
    fill: "#CB2E2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73 33.3846L73 -2.14577e-06L64.5897 8.61538L64.5897 42L73 33.3846Z",
    fill: "#BE1B1B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 8.61538,
    width: 32.5897,
    height: 33.3846,
    fill: "#E15555"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.134 36.5C48.5189 35.8333 49.4811 35.8333 49.866 36.5L61.1244 56C61.5093 56.6667 61.0281 57.5 60.2583 57.5H37.7417C36.9719 57.5 36.4907 56.6667 36.8756 56L48.134 36.5Z",
    fill: "#FFCBC4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 53,
    r: 1,
    fill: "#E15555"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43C49.5523 43 50 43.4477 50 44V50C50 50.5523 49.5523 51 49 51V51C48.4477 51 48 50.5523 48 50V44C48 43.4477 48.4477 43 49 43V43Z",
    fill: "#E15555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGraphic);
export default __webpack_public_path__ + "static/media/error_graphic.78e0c935528fb545cca53ce363e0ccab.svg";
export { ForwardRef as ReactComponent };